import { useState, useCallback } from 'react';
import { ItemToReturn, OrderDetailsSessionDataV2 } from '@src/models/returns';
import { setRefundValues } from '@src/stores/summaryStore';
import { fetchRefundEstimationAPI } from '@src/utils/api-helpers';
import { buildRefundEstimationRequest } from '@src/utils';

interface UseRefundCalculatorProps {
  orderDetailsV2: OrderDetailsSessionDataV2 | undefined;
}

export const useRefundCalculator = ({
  orderDetailsV2,
}: UseRefundCalculatorProps) => {
  const [isRefundCalculatorLoading, setIsRefundCalculatorLoading] =
    useState(false);

  const calculateRefund = useCallback(
    async (selectedItems: ItemToReturn[]) => {
      if (!orderDetailsV2) return;

      const refundRequest = buildRefundEstimationRequest(
        orderDetailsV2,
        selectedItems,
      );
      setIsRefundCalculatorLoading(true);

      try {
        const refundAmount = await fetchRefundEstimationAPI(refundRequest);
        setRefundValues(refundAmount);
      } catch {
        setRefundValues(undefined);
      } finally {
        setIsRefundCalculatorLoading(false);
      }
    },
    [orderDetailsV2],
  );

  return {
    isRefundCalculatorLoading,
    calculateRefund,
  };
};
